<template>
  <div
    v-if="visble"
    class="processing-tip"
    :style="{ bottom: expand ? '180px' : '134px' }"
  >
    <div class="processing-header">
      <div class="title">
        Pending Processing
      </div>
      <div
        @click="visble = false"
        class="close"
      >
        <img
          src="@/assets/images/icon-close-light.svg"
          alt=""
        >
      </div>
    </div>
    <div class="text">
      Your request will be processed within 1 business day. Note: Some items may face customs restrictions in your country. We're verifying clearance status. While waiting, consult our category experts free of charge.
    </div>
    <div
      @click="contactUs"
      class="contact-us"
    >
      Free Expert Consultation Now!
      <img
        src="@/assets/images/icon-arrow-right.svg"
        alt=""
      >
    </div>
  </div>
</template>

<script setup>
import { useContactApp } from '@/hooks/useContactApp'

defineProps({
  expand: {
    type: Boolean,
    default: false
  }
})

const { contactUs } = useContactApp()

const visble = defineModel()
</script>

<style lang='less' scoped>
 .processing-tip {
  position: fixed;
  width: 100%;
  background-color: #eff4fd;
  padding: 0 16px 16px;
  z-index: 999;
  transition: all .3s ease-in;
  overflow: hidden;

  .processing-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 48px;
    .title {
      color: #041f6a;
      font-size: 14px;
      font-family: mon-600;
    }
  }
  .text {
    color: #041f6a;
    font-size: 12px;
    font-family: mon-500;
    line-height: 16px;
  }
  .contact-us {
    display: flex;
    align-items: center;
    margin-top: 8px;
    color: #041f6a;
    font-size: 12px;
    font-family: mon-600;
    text-decoration: underline;
  }
}
</style>
